module.exports = __webpack_public_path__ + "static/media/soft-fit-cereja-trans.e33b7ca6.webp";